import axios from 'axios'
import debounce from 'lodash/debounce'

import { SEARCH as ENDPOINT } from '../common/endpoints'

const MIN_SEARCH_LENGTH = 3

const makeAsyncSearch = () => {
	let _filterInputs = []
	let _filterNames = []
	let _filterValues = {}
	let _stringInput
	let _handleSearch
	let _axiosCancelToken
	let _searchParams = {}
	let _settings
	let _resultsWrapper
	let _popupWrapper
	const Lang = window.motostorm?.lang
	const platform = window.navigator?.userAgentData?.platform || window.navigator?.platform || ''
	const needsWheelScrollFallback = /Mac|iPhone|iPad|iPod/.test(platform)
	var page = 2
	let _isLoadingPage = false
	let _hasLastPage = false
	const PAGINATION_SCROLL_OFFSET = 240

	function _addFilter(inputs) {
		_filterInputs = []
		_filterInputs = _filterInputs.concat([...inputs])
		_filterNames = [...new Set(_filterInputs.map((input) => input.name))]
	}

	function _getFilterValue(name) {
		const inputs = _filterInputs.filter((input) => input.name === name)
		if (!inputs.length) {
			return undefined
		}

		const values = inputs
			.map((input) => {
				switch (input.type) {
					case 'checkbox':
					case 'radio':

						if (input.checked) {
							return input.value
						}
						return
					case 'number':
						return parseFloat(input.value)
					default:
						return input.value
				}
			})
			.filter((value) => value)

		switch (values.length) {
			case 0:
				return undefined
			case 1:
				return values[0]
			default:
				return values[0]
		}
	}

	function _getAllFilterValues(e) {
		const r = []

		_filterNames.forEach((name, key) => {
			if (e.target.name == [name]){
				if(e.target.checked){
					r[name] = e.target.value
				}
			} else {
				const value = _getFilterValue(name)
				if (value !== undefined) {
					r[name]=value
				}
			}
		})
		return r
	}

	function _handleInputFilter(e) {
		page = 2
		_isLoadingPage = false
		_hasLastPage = false
		_filterValues = _getAllFilterValues(e)
		_handleSearch(e)
	}
	
	function _handlePagination(e){
		const scrollableElement = e.currentTarget || e.target
		const distanceFromBottom = scrollableElement.scrollHeight - scrollableElement.scrollTop - scrollableElement.clientHeight

		if (!_isLoadingPage && !_hasLastPage && distanceFromBottom <= PAGINATION_SCROLL_OFFSET) {
			_isLoadingPage = true
			// qui va inserita la funzione di caricamento
			_filterValues = _getAllFilterValues(e)
			_filterValues['pagination'] =  true
			_filterValues['page_no'] =  page
			_stringInput = document.getElementById('id-header-search')
			const productsWrapper = document.querySelector('.j-search-popup__cards-grid')
			const loaderTemplate = _popupWrapper?.querySelector(':scope > .c-search-popup__loader')
			const paginationLoader = loaderTemplate?.cloneNode(true)

			if (paginationLoader && productsWrapper) {
				paginationLoader.classList.add('c-search-popup__pagination-loader')
				paginationLoader.style.display = 'flex'
				paginationLoader.style.justifyContent = 'center'
				paginationLoader.style.alignItems = 'center'
				paginationLoader.style.gridColumn = '1 / -1'
				paginationLoader.style.minHeight = '80px'
				productsWrapper.appendChild(paginationLoader)
			}

			_searchParams = {
				lang: Lang,
				q: _stringInput.value,
				..._filterValues,
			}

			axios.get(ENDPOINT, {
				params: _searchParams,
			})
			.then(resp => {
				paginationLoader?.remove()
				productsWrapper.innerHTML += resp.data.html
				// if res last page is true remove event listener
				if (resp.data.results.lastpage === true){
					_hasLastPage = true
					scrollableElement.removeEventListener('scroll', _handlePagination)
					scrollableElement.removeEventListener('wheel', _handleWheel)
				}
			})
			.catch(err => {
				// Handle Error Here
				console.error(err);
			})
			.finally(() => {
				_isLoadingPage = false
				paginationLoader?.remove()
			})
			page++
		}
	}

	function _handleWheel(e) {
		if (!needsWheelScrollFallback) {
			return
		}

		if (e.target.closest && e.target.closest('.c-search-popup__filters-group')) {
			return
		}

		const scrollableElement = _resultsWrapper || document.querySelector('.c-search-popup__products')

		if (!scrollableElement || e.deltaY === 0) {
			return
		}

		const previousScrollTop = scrollableElement.scrollTop
		scrollableElement.scrollTop += e.deltaY
		const distanceFromBottom = scrollableElement.scrollHeight - scrollableElement.scrollTop - scrollableElement.clientHeight
		const shouldCheckPagination = scrollableElement.scrollTop !== previousScrollTop || (e.deltaY > 0 && distanceFromBottom <= PAGINATION_SCROLL_OFFSET)

		if (shouldCheckPagination) {
			e.preventDefault()
			_handlePagination({
				currentTarget: scrollableElement,
				target: scrollableElement,
			})
		}
	}

	function _addPaginationListeners() {
		_resultsWrapper = document.querySelector('.c-search-popup__products')
		_popupWrapper = document.querySelector('.j-search-popup')

		if(_resultsWrapper){
			_resultsWrapper.removeEventListener('scroll', _handlePagination)
			_resultsWrapper.removeEventListener('wheel', _handleWheel)
			_resultsWrapper.addEventListener('scroll', _handlePagination)
			_resultsWrapper.addEventListener('wheel', _handleWheel, { passive: false })
		}

		if(_popupWrapper){
			_popupWrapper.removeEventListener('wheel', _handleWheel)
			_popupWrapper.addEventListener('wheel', _handleWheel, { passive: false })
		}
	}

	function init(settings) {
		if (!settings || !settings.searchInput) {
			return
		}

		_settings = settings

		const allFilterInputs = document.querySelectorAll('.j-filter-search__input')
		const closePopupMob = document.querySelector('.j-search-popup__close-button')

		if (closePopupMob) {

			closePopupMob.addEventListener('click', (e) => {
				document.body.classList.remove('has-searchpopup-open')
			})	
		}
		
		_addFilter(allFilterInputs)
		_stringInput = settings.searchInput

		_handleSearch = debounce(async (e) => {

			if (e.type == 'keyup' || e.type == 'paste') {
				_filterValues = {}
				page = 2
				_isLoadingPage = false
				_hasLastPage = false
			}
			
			if (e.type == 'focus') {
				_filterValues['pagination'] = null
				_filterValues['page_no'] =  null
			}
			
			// close everything on esc key
			if (e.keyCode === 27) {
				_axiosCancelToken?.cancel('Operation canceled due to abort.')
				e.target.value = ''
				if (settings.callback && typeof settings.callback === 'function') {
					settings.callback(null, true)
				}
			}

			if (e.target.value.length < MIN_SEARCH_LENGTH) {
				// if not enough letters for a search, return and set loading screen
				if (settings.callback && typeof settings.callback === 'function') {
					settings.callback()
				}
				return
			}

			if (typeof _axiosCancelToken != typeof undefined) {
				_axiosCancelToken.cancel('Operation canceled due to new request.')
			}

			// Show the loader as soon as a valid search starts. Previously the
			// callback was invoked only after the response, leaving stale results
			// visible for the whole request.
			if (settings.callback && typeof settings.callback === 'function') {
				settings.callback()
			}

			_axiosCancelToken = axios.CancelToken.source()

			_searchParams = {
				lang: Lang,
				q: _stringInput.value,
				..._filterValues,
			}

			const res = await axios.get(ENDPOINT, {
				cancelToken: _axiosCancelToken.token,
				params: _searchParams,
			})

			if (settings.callback && typeof settings.callback === 'function') {
				destroy()
				settings.callback(res)
			}
			
			_addPaginationListeners()
			
		}, 300)

		_stringInput.addEventListener('keyup', _handleSearch)
		_stringInput.addEventListener('paste', _handleSearch)
		
		if(_stringInput.value.length >= 3){
			_stringInput.addEventListener('focus', _handleSearch)
		}

		allFilterInputs.forEach(item => {
			item.addEventListener('change', _handleInputFilter)
		})		
	}
	
	function reinit() {
		init(_settings)
	}
	
	function focusOnSearch(){
		
	}

	function destroy() {
		_stringInput.removeEventListener('focus', _handleSearch)
		_stringInput.removeEventListener('keyup', _handleSearch)
		_stringInput.removeEventListener('paste', _handleSearch)

		_filterInputs.forEach((input) =>
			input.removeEventListener('change', _handleInputFilter)
		)

		if(_resultsWrapper){
			_resultsWrapper.removeEventListener('scroll', _handlePagination)
			_resultsWrapper.removeEventListener('wheel', _handleWheel)
		}

		if(_popupWrapper){
			_popupWrapper.removeEventListener('wheel', _handleWheel)
		}
	}

	return {
		init,
		reinit,
		cancel() {
			_axiosCancelToken?.cancel('Operation canceled because search was cleared.')
		},
		destroy,
		get searchParams() {
			return _searchParams
		},
	}
}

export default makeAsyncSearch
